import MainSearchResult from "~/models/MainSearchResult";

export default definePayloadPlugin(() => {
  definePayloadReducer("MainSearchResult", (value) => {
    if (value instanceof MainSearchResult) {
      return value.toPayload();
    }
    return undefined;
  });

  definePayloadReviver("MainSearchResult", (value) => {
    if (value && typeof value === "object") {
      return MainSearchResult.fromPayload(value);
    }
    return value;
  });
});
